<template>
  <div>
    <v-container
      fluid
      grid-list-md
    >
      <h1 class="text-h5 mb-6">{{ $t('Parked Receipts') }}</h1>
      <parked-receipts-table include-search />
    </v-container>
  </div>
</template>

<script>
import Vue from 'vue'
import ParkedReceiptsTable from '@/components/receipts/ParkedReceiptsTable'

export default {
  metaInfo () {
    return { title: this.pageTitle }
  },

  components: {
    ParkedReceiptsTable
  },

  data: () => ({
    pageTitle: Vue.i18n.translate('Parked Receipts')
  })
}
</script>



// WEBPACK FOOTER //
// src/views/receipts/Parked.vue